import * as yup from 'yup';

import {
  confirmPasswordFieldSchema,
  newPasswordFieldSchema,
} from 'schemas/passwordRules';

const phoneComplete = (value?: string) => (value || '').replace(/\D/g, '').length >= 11;

export const registrationSchema = yup.object().shape({
  method: yup.string().oneOf(['email', 'phone']).required(),
  email: yup.string().when('method', {
    is: 'email',
    then: (schema) =>
      schema.email('Проверьте адрес: например, name@example.com').required('Укажите почту'),
    otherwise: (schema) => schema.strip(),
  }),
  phone: yup.string().when('method', {
    is: 'phone',
    then: (schema) =>
      schema
        .required('Укажите телефон')
        .test('phone', 'Укажите полный номер телефона', (value) => phoneComplete(value)),
    otherwise: (schema) => schema.strip(),
  }),
  password: yup.string().when('method', {
    is: 'email',
    then: () => newPasswordFieldSchema({ requiredMessage: 'Пароль обязателен' }),
    otherwise: (schema) => schema.strip(),
  }),
  confirmPassword: yup.string().when('method', {
    is: 'email',
    then: () => confirmPasswordFieldSchema('password'),
    otherwise: (schema) => schema.strip(),
  }),
  role: yup.string().oneOf(['student', 'teacher']).required('Выберите роль'),
  studentRegistrantType: yup.string().when('role', {
    is: 'student',
    then: (schema) => schema.oneOf(['self', 'parent']).required('Выберите, для кого регистрация'),
    otherwise: (schema) => schema.notRequired(),
  }),
  name: yup.string().trim().required('Укажите имя'),
  // Figma 21:9440: фамилия, отчество и дата рождения репетитора заполняются в анкете,
  // без них анкету нельзя отправить на проверку (сервер: tutor_profile_readiness).
  surname: yup.string().trim().optional(),
  patronymic: yup.string().when('role', {
    is: 'teacher',
    then: (schema) => schema.optional(),
    otherwise: (schema) => schema.strip(),
  }),
  // p6: пол владельца аккаунта обязателен всем, включая родителя; имя и пол ребёнка убраны (p5).
  gender: yup.string().oneOf(['male', 'female'], 'Выберите пол').required('Выберите пол'),
  childName: yup.string().when(['role', 'studentRegistrantType'], {
    is: (role: string, reg: string) => role === 'student' && reg === 'parent',
    then: (schema) => schema.optional(), // p5: имя ребёнка не спрашиваем
    otherwise: (schema) => schema.strip(),
  }),
  childGender: yup.string().when(['role', 'studentRegistrantType'], {
    is: (role: string, reg: string) => role === 'student' && reg === 'parent',
    then: (schema) => schema.oneOf(['male', 'female', ''], 'Выберите пол ребёнка').optional(),
    otherwise: (schema) => schema.strip(),
  }),
  birthDate: yup.string().optional(),
  privacyConsent: yup
    .boolean()
    .oneOf([true], 'Нужно согласие на обработку персональных данных')
    .required('Нужно согласие на обработку персональных данных'),
});

export type TRegistration = yup.InferType<typeof registrationSchema>;
